import { Box, TextField, Button } from "@mui/material";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { format } from "date-fns";
import React from "react";

interface DateTimePickerProps {
  date: Date;
  time: Date;
  onDateChange: (value: Date) => void;
  onTimeChange: (value: Date) => void;
  onClose: () => void;
}

export const DateTimePicker: React.FC<DateTimePickerProps> = ({
  date,
  time,
  onDateChange,
  onTimeChange,
  onClose,
}) => {
  return (
    <Box
      sx={{
        bgcolor: "common.white",
        boxShadow: 3,
        borderRadius: 2,
        border: "1px solid",
        borderColor: "grey.200",
        p: 2,
        width: 288, // equivalent to w-72 in Tailwind (72 * 4 = 288px)
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <DatePicker
            label="Data"
            minDate={new Date()}
            disablePast
            value={date}
            onChange={onDateChange}
            slots={{
              textField: TextField,
            }}
            slotProps={{
              textField: { fullWidth: true },
            }}
          />
          <TimePicker
            label="Ora"
            value={time}
            onChange={onTimeChange}
            slots={{
              textField: TextField,
            }}
            slotProps={{
              textField: { fullWidth: true },
            }}
            disablePast={format(date, "yyyy-MM-dd") === format(new Date(), "yyyy-MM-dd")}
            ampm={false}
          />
        </Box>
      </LocalizationProvider>
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="primary" onClick={onClose}>
          Salva
        </Button>
      </Box>
    </Box>
  );
};
